<script lang="ts">
  import { _ } from 'svelte-i18n';

  import RegionFilters from '$lib/components/RegionFilters.svelte';
  import { scheduleCount } from '$lib/stores/guided';
  import {
    cantons,
    centerPostalCode,
    languages,
    postalCodes,
    radiusKm
  } from '$lib/stores/selection';

  /**
   * Where the companies are.
   *
   * # The sidebar's own control, embedded
   *
   * This offered cantons and the language-region presets and nothing else,
   * while the filter panel beside it offered five ways to say where: a radius
   * around a postal code, a list of postal codes, cantons, the presets, and
   * language. A customer who works by postal code had to leave the guide to
   * say so.
   *
   * So the guide uses the same component. It writes to the same stores either
   * way — `embedded` only drops the heading and the "filter by region at all"
   * checkbox, which this step has already asked by existing.
   *
   * # Counting is watched, not called
   *
   * The other steps call `scheduleCount` at each mutation because they own
   * their controls. This one does not own it, so it watches the stores it can
   * change instead. Reaching into RegionFilters to add a callback at every
   * mutation point would be five call sites in a component the sidebar also
   * uses, to say something the stores already say.
   */
  $: void ($cantons, $postalCodes, $languages, $centerPostalCode, $radiusKm, scheduleCount());
</script>

<div class="space-y-4">
  <RegionFilters embedded />

  <p class="text-xs text-gray-500">{$_('guided.region.skipHint')}</p>
</div>
